import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import ClockIcon from '@lt/components/icons-react/rebrand/Clock';
import PriceChecker from '../../../../components/PriceChecker';
import { HOTEL_SEARCHER_REPEAT_DELAY } from '../../constants';

import styles from './searcher.module.css';

const SearcherTimer = ({ lastUpdated }) => {
  const { t } = useTranslation();
  if (!lastUpdated) return null;
  return (
    <PriceChecker
      className={styles.searcherTimerPriceChecker}
      lastUpdated={lastUpdated}
      timeout={HOTEL_SEARCHER_REPEAT_DELAY}
      text={t('hotel.searcherTimer', { context: 'timer' })}
      fetchingText={t('hotel.searcherTimer', { context: 'update' })}
      icon={<ClockIcon className={styles.searcherTimerIcon} />}
    />
  );
};

SearcherTimer.defaultProps = {
  lastUpdated: null,
};

SearcherTimer.propTypes = {
  lastUpdated: PropTypes.number,
};

export default SearcherTimer;
